import { Tag, Spin } from 'antd';
import React, { useState, useEffect, useRef } from 'react';

const PhotoCard = (props) => {
    const [hover, setHover] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Start as loading
    const [displaySrc, setDisplaySrc] = useState(null); // Start with no image
    const prevPhotoRef = useRef(null); // Start with null
    const imgRef = useRef(null);
    
    const photo = props.photo;
    const setFocus = props.setFocus;

    useEffect(() => {
        // If this is a new card or the photo ID changed
        if (!prevPhotoRef.current || prevPhotoRef.current.id !== photo.id) {
            // Start/continue loading state
            setIsLoading(true);
            
            // Preload the new image
            const img = new Image();
            img.src = photo.image_lores;
            
            img.onload = () => {
                // Image is downloaded and cached, now swap the src
                setDisplaySrc(photo.image_lores);
                // Wait a bit to ensure React has rendered the new img tag
                setTimeout(() => {
                    setIsLoading(false);
                }, 100);
            };
            
            img.onerror = () => {
                // On error, just swap immediately
                setDisplaySrc(photo.image_lores);
                setIsLoading(false);
            };
            
            prevPhotoRef.current = photo;
        }
    }, [photo]);

    return (
      <article
        id={photo.id} 
        class="card" 
        onClick={() => setFocus(photo)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          border: (hover)? "solid 2px #404040" : "solid 2px #303030",
          borderRadius: "8px",
          transition: "all 0.2s ease",
          position: "relative"
        }}
      >
        {photo.tags?.length > 0 &&
          (
        <nav class="links" style={{
          opacity: (hover)? 1 : 0.6, 
          transition: "all 0.2s ease"
        }}>
          {photo.tags?.map(tag => <Tag color="#30305080" bordered={true}>{tag.name}</Tag>)}
        </nav>
          )
        }
        <img 
          ref={imgRef}
          src={displaySrc} 
          alt={photo.title}
          style={{
            filter: isLoading ? 'blur(8px)' : 'none',
            opacity: displaySrc ? 1 : 0, // Hide if no src yet
            transition: 'filter 0.3s ease, opacity 0.3s ease'
          }}
        />
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none'
          }}>
            <Spin size="large" />
          </div>
        )}
        <div class="caption" style={{
          opacity: (hover)? 1 : 0.6, 
          transition: "all 0.3s ease", 
        }}>
          {photo.subject.name}
        </div>
      </article>
    )
}

export default PhotoCard;